export default "__VITE_ASSET__5a0d88db__"